import { cx } from "cva";

import { OpenInNewIcon } from "../Icon";
import { ButtonLinkProps, variants } from ".";

export const ButtonExternalLink = ({
  className,
  disabled,
  children,
  variant,
  width,
  color,
  href,
  target = "_blank",
  rel = "noopener noreferrer",
  onClick,
  ...props
}: Readonly<ButtonLinkProps>) => (
  <a
    href={href}
    aria-disabled={disabled}
    className={cx(className, variants({ variant, width, color }))}
    tabIndex={disabled ? -1 : undefined}
    target={target}
    rel={rel}
    onClick={disabled ? (event) => event.preventDefault() : onClick}
    {...props}
  >
    {children}
    <span className="sr-only">(別ウィンドウで開きます)</span>
    <OpenInNewIcon />
  </a>
);
